import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LegalDocument } from '../../components/Legalese/LegalDocument';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';

const LegalComponent = () => {
  const history = useHistory();
  const { doc } = useParams<{ doc: 'privacy' | 'cookie' | 'tos' }>();
  const [activeTab, setActiveTab] = useState('privacy');

  const { t } = useTranslation();

  useEffect(() => {
    if (!doc) history.replace('/legal/privacy');
    else setActiveTab(doc);
  }, []);

  useEffect(() => {
    history.replace(`/legal/${activeTab}`);
  }, [activeTab]);

  return (
    <>
      <Title>Legal</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <Tabs activeKey={activeTab} onSelect={setActiveTab} variant={'pills'} mountOnEnter={true} unmountOnExit={true}>
          <Tab eventKey={'privacy'} title={t('legalese.labels.privacy')}>
            <div className={'mt-3'}>
              <LegalDocument doc={'privacy'} />
            </div>
          </Tab>
          <Tab eventKey={'cookie'} title={t('legalese.labels.cookie')}>
            <div className={'mt-3'}>
              <LegalDocument doc={'cookie'} />
            </div>
          </Tab>
          <Tab eventKey={'tos'} title={t('legalese.labels.tos')}>
            <div className={'mt-3'}>
              <LegalDocument doc={'tos'} />
            </div>
          </Tab>
        </Tabs>
      </Container>

      <Footer />
    </>
  );
};

export default LegalComponent;
